import { API } from "../../apiEndPoints/website/apiEndPoints";
import {
  axiosDelete,

  axiosPost,
} from "../../axios/axiosMiddleware";
import createAxiosInstance, { axiosPatch, axiosPost2 } from "../../axios/axiosMiddleware2";
import { store } from "../../redux/store";
const axiosInstance = createAxiosInstance(store);
export const LoginUser = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.LOGIN, data);
};

export const LogoutApi = () => {
  return axiosDelete(API?.AUTH?.LOGIN);
};

export const ForgotPasswordApi = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.FORGOT_PASSWORD, data);
};

export const LoginWIthEmail = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.GETOTP, data);
};

export const VerifyOtp = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.VERIFY_OTP, data);
};
export const SetNewPassword = (id: any, data: any) => {
  return axiosPatch(axiosInstance,`${API?.AUTH?.SET_NEW_PASSWORD}/${id}`, data);
}
export const VerifyOtpForgetPassword = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.VERIFY_OTP_FORGET_PASSWORD, data);
};

export const ResendOtp = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.RESEND_OTP, data);
};
export const ResendOtpForgetPassword = (data: any) => {
  return axiosPost2(axiosInstance,API?.AUTH?.RESEND_OTP_FORGET_PASSWORD, data);
};
export const ResetPasswordApi = (params: any, id: any, data: any) => {
  return axiosPatch(axiosInstance,`${API.AUTH.FORGOT}/${id}/${params}`, data);
};
export const ResetPasswordAfterLogin = (id: any, data: any) => {
  
  return axiosPatch(axiosInstance,`${API.AUTH.SET_NEW_PASSWORD}/${id}`, data);
};

export const Register = (data: any) => {
  return axiosPost(API?.AUTH?.REGISTER, data);
};
